// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.topBanner[data-v-5b3c7a52] {\n  position: relative;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  min-width: 1200px;\n  z-index: 2;\n  height: 170px;\n  margin-top: 64px;\n}\n.topBanner img[data-v-5b3c7a52] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);
// Exports
module.exports = exports;
